import * as THREE from 'three';

/**
 * Returns true when `root` contains at least one {@link THREE.Mesh} with geometry
 * that has position attribute data. Used for prefab thumbnail readiness so we do not
 * treat "loaded" as only `Object3D.children.length > 0` (single-root mesh GLTFs often
 * have no child nodes).
 */
export function thumbnailSubtreeHasRenderableMesh(root: THREE.Object3D | null): boolean {
  if (!root) {
    return false;
  }

  let found = false;
  root.traverse(object => {
    if (found || !(object instanceof THREE.Mesh) || !object.geometry) {
      return;
    }
    const position = object.geometry.getAttribute('position');
    found = Boolean(position && position.count > 0);
  });

  return found;
}
